import { Component, ElementRef, Inject, inject, OnInit, signal, viewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { FormInputComponent } from '../form-input/form-input.component';
import { LicenseService } from '../../../core/services';
import { FormService } from '../../../shared/services';

@Component({
  selector: 'app-form-dialog-invites-learner',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    FormInputComponent
  ],
  templateUrl: './dialog-invites-learner.component.html',
  styleUrl: './dialog-invites-learner.component.scss'
})
export class DialogInvitesLearnerComponent implements OnInit {
  private licenseService = inject(LicenseService);
  private formService = inject(FormService);
  readonly dialogRef = inject(MatDialogRef<DialogComponent>);
  initialFocus = viewChild<ElementRef>('initialFocus');
  formInviteLearner = new FormGroup({});
  inviteLearnerFormFields = signal<any>({});
  isSubmitting = false;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  
  ngOnInit(): void {
    this.licenseService.getInviteLearnerForm().subscribe((res) => {
      this.inviteLearnerFormFields.set(res);
      this.formInviteLearner = this.formService.createForm(this.inviteLearnerFormFields());
    });
  }

  ngAfterViewInit(): void {
    // this.initialFocus()?.nativeElement.focus();
  }
  
  onSubmit(): void {
    if (this.formInviteLearner.invalid) {
      this.formInviteLearner.markAllAsTouched();
      return;
    }
    
    this.isSubmitting = true;
    this.dialogRef.close(this.formInviteLearner.value);
  }
  
  onCancel(): void {
    this.dialogRef.close(false);
  }
}